/**
 * 上户状态
 * 仅限签约月嫂
 * 0:待申请上户 30:已申请上户 35:驳回上户 40:已确认上户
 *
 * 对应接口定义
 */
export const ORDER_WORK_STATE_SHANG_HU_ENUM = {
  /**
   * 待申请上户
   */
  DAI_SHENGQING_SHANG_HU: 0,
  /**
   * 已申请上户
   */
  YI_SHENGQING_SHANG_HU: 30,
  /**
   * 驳回上户
   */
  BOHUI_SHANGHU: 35,
  /**
   * 已确认上户
   */
  YI_QUEREN_SHANGHU: 40
}

/**
 * 签约月嫂售后申请状态Service After Sale State
 *  refundState：0 // 0申请 1 撤销 2 结束
 *  sasState:0 //当前售后状态 0 申请 1撤销 2 结束
 */
export const YS_REFUND_STATE_ENUM = {
  /**
   * 申请,已点击申请退款按钮
   */
  HAS_APPLIED: 0,
  /**
   * 撤销
   */
  HAS_CANCEL: 1
}

export const YS_S_AFTER_SALE_STATE_ENUM = {
  /**
   * 申请,已点击申请售后
   */
  HAS_APPLIED: 0,
  /**
   * 撤销
   */
  HAS_CANCEL: 1
}

export const IS_SELF_YUESAO = 6 //甄选想月嫂
